module.exports = __webpack_public_path__ + "img/landingpage-video-mobile.28fbae5d.svg";